import React, { useContext, useState } from 'react'

import UploadForm from '../components/Admin/Media/UploadForm'
import ImageGrid from '../components/Admin/Media/ImageGrid'
import Modal from '../components/Admin/Media/Modal'
import StateContext from '../StateContext'
import LightboxPage from '../components/Public/Lightbox/Lightbox'
import Albums from '../components/Public/Media/Albums'
import AddAlbum from '../components/Admin/Media/AddAlbum'
import WpMedia from '../components/Media/WpMedia'

function MediaPage() {

	const appState = useContext(StateContext)

	const [selectedImg, setSelectedImg] = useState(null)

		const [show, setShow] = useState(false)
	const [activeItem, setActiveItem] = useState("1");

	function toggle(tab) {
		if (activeItem !== tab) {
			setActiveItem(tab)
		}
    }
    
    function toggleWpMedia() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

	return (
		<div className="container">

			<div className="row my-2">
				<div className="col-4">
					<button className={activeItem === "1" ? "btn btn-primary btn-block active" : "btn btn-primary btn-block"} onClick={() => toggle("1")}>Galleri</button>
				</div>
				<div className="col-4">
					<button className={activeItem === "2" ? "btn btn-primary btn-block active" : "btn btn-primary btn-block"} onClick={() => toggle("2")}>Album</button>
				</div>
				<div className="col-4">
					<button className={activeItem === "3" ? "btn btn-primary btn-block active" : "btn btn-primary btn-block"} onClick={() => toggle("3")}>Legg til media</button>
				</div>
			</div>

			{activeItem === "1" && (
				<div>
					{appState.loggedIn && (
                        <div className="card card-header" onClick={() => toggleWpMedia()}>
                            <div>
                                Wp Media
                                <span className="float-right"><i className={`fas fa-chevron-${show ? "up" : "down"}`}></i></span>
                            </div>
						    
                        </div>
                    )}
					{show && appState.loggedIn && <WpMedia />}

                    <LightboxPage />
				</div>
			)}
			{activeItem === "2" && (
				<React.Fragment>
					{appState.loggedIn && <AddAlbum />} 
					<Albums />

				</React.Fragment>
			)}
			{activeItem === "3" && (
				<React.Fragment>
					{appState.loggedIn ? (
						<>
							<UploadForm />
							<ImageGrid setSelectedImg={setSelectedImg} />
							{selectedImg && <Modal selectedImg={selectedImg} setSelectedImg={setSelectedImg} />}
						</>)
						:
						<p>Logg inn for å legge til media</p>
					}
				</React.Fragment>
			)}

		</div>
	)
}
export default MediaPage
